<template>
    <div class="background-color-picker-container">
        <v-btn v-for="(color, index) in colors"
               :key="index"
               @click="change(color)"
        >
            <div class="color-container">
                <div class="color-container__content" :class="{'--active': color == $store.state.UI.backgroundColor}"
                     :style="{ 'background-color': color }"></div>
            </div>
        </v-btn>
    </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
    data() {
        return {
            colors: [
                '#000000',
                '#191919',
                '#333333'
            ]
        }
    },

    mounted() {
        let color = Cookies.get('BackgroundColor');
        if (color) this.$store.commit('UI/SET_BACKGROUND_COLOR', color);
    },

    methods: {
        change(color) {
            Cookies.set('BackgroundColor', color);
            this.$store.commit('UI/SET_BACKGROUND_COLOR', color);
        }
    }
}
</script>

<style lang="scss" scoped>
.background-color-picker-container {
    display: flex;

    .color-container {
        width: 1.7rem;
        height: 1.7rem;
        display: flex;
        align-items: center;
        justify-content: center;

        &__content {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid var(--font-default-color);
            cursor: pointer;

            &.--active {
                border-color: white;
            }
        }
    }
}
</style>
